import { forwardRef, type ComponentPropsWithoutRef, type ElementRef } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { cn } from '@/utils/helpers';

export const Modal = Dialog.Root;
export const ModalTrigger = Dialog.Trigger;
export const ModalPortal = Dialog.Portal;
export const ModalTitle = Dialog.Title;
export const ModalDescription = Dialog.Description;

export const ModalOverlay = forwardRef<ElementRef<typeof Dialog.Overlay>, ComponentPropsWithoutRef<typeof Dialog.Overlay>>(
  ({ className, ...props }, ref) => {
    return <Dialog.Overlay ref={ref} className={cn('ui-modal-overlay', className)} {...props} />;
  }
);
ModalOverlay.displayName = 'ModalOverlay';

export const ModalContent = forwardRef<ElementRef<typeof Dialog.Content>, ComponentPropsWithoutRef<typeof Dialog.Content>>(
  ({ className, ...props }, ref) => {
    return (
      <ModalPortal>
        <ModalOverlay />
        <Dialog.Content ref={ref} className={cn('ui-modal', className)} {...props} />
      </ModalPortal>
    );
  }
);
ModalContent.displayName = 'ModalContent';

export const ModalClose = Dialog.Close;

